import { CmsImageType } from 'utils/cms/types';
import CustomMarkdown from '../CustomMarkdown';

export type EmptyOptions = {
  title?: string;
  text?: string;
  image?: CmsImageType;
};

type EmptyOptionsProps = {
  options: EmptyOptions;
};

const EmptyList = ({ options }: EmptyOptionsProps) => {
  const { text, title, image } = options;

  return (
    <div className="text-center text-neutral-800">
      {image && (
        <img
          alt={image.alt}
          className="m-auto"
          height={Number(image.sizes['medium-height'])}
          src={image.sizes.large}
          width={Number(image.sizes['medium-width'])}
        />
      )}
      {title && <h4 className="title-4 mt-4 mt-1 text-neutral-900">{title}</h4>}
      {text && <CustomMarkdown className="md-regular text-neutral-800">{text}</CustomMarkdown>}
    </div>
  );
};

export default EmptyList;
